import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ProjectType } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error, { id: number }, ProjectType>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useDeleteProjectTypeRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { id: number }, ProjectType>(
    [Entities.ProjectTypes, 'delete'],
    async ({ id }) => {
      const { data } = await api.v1AdminProjectsTypesTypeIdDelete(id)
      return data
    },
    { ...options },
  )
}
